import styled from 'styled-components'

const Shape1Wrapper = styled.div`
  z-index: 0;
  width: 100%;
  height: 100%;

  .yellow {
    width: 10%;
    height: 10%;
    transform: rotate(-330deg);
    border-radius: 6px;
    background-color: ${({ theme }) => theme.colors.secondary};
    position: absolute;
    top: 44%;
    left: 17%;
  }

  .orange {
    width: 50%;
    height: 50%;
    transform: rotate(-330deg);
    border-radius: 7px;
    background-color: ${({ theme }) => theme.colors.pumpkinOrange};
    position: absolute;
    top: 8%;
    right: 8%;
  }

  .blue {
    width: 19%;
    height: 19%;
    transform: rotate(-330deg);
    border-radius: 8px;
    background-color: ${({ theme }) => theme.colors.primary};
    position: absolute;
    top: 40%;
    right: 44%;
  }
`

export const Shape3 = ({ ...rest }) => (
  <Shape1Wrapper {...rest}>
    <div className="yellow" />
    <div className="orange" />
    <div className="blue" />
  </Shape1Wrapper>
)
